import { LoginContext } from "@/lib/context/login-context";
import { getHrefFromWindow } from "@/lib/helpers/url-utils";
import { useWidget } from "@/lib/hooks/use-widget";
import { useStytch } from "@stytch/react";
import React, { FC, PropsWithChildren, useCallback, useState } from "react";

const LoginProvider: FC<PropsWithChildren> = ({ children }) => {
  const stytch = useStytch();
  const { redirectUrl } = useWidget();
  const [isSigningIn, setSigningIn] = useState(false);

  const startOauth = useCallback(
    (noRedirect = false) => {
      setSigningIn(true);

      const redirect = encodeURIComponent(getHrefFromWindow() || "");

      const signinoptions = JSON.stringify(noRedirect ? {} : { redirect });

      stytch.oauth.google.start({
        login_redirect_url: `${redirectUrl}/auth?options=${signinoptions}`,
        signup_redirect_url: `${redirectUrl}/auth?options=${signinoptions}`,

        custom_scopes: [
          "openid",
          "profile",
          "email",
          "https://www.googleapis.com/auth/drive.appdata",
        ],
      });
    },
    [redirectUrl, stytch.oauth.google],
  );

  return (
    <LoginContext.Provider value={{ isSigningIn, startLogin: startOauth }}>
      {children}
    </LoginContext.Provider>
  );
};

export default LoginProvider;
